export const UPDATE_REPORT_SCOPE = 'UPDATE_REPORT_SCOPE';

export const updateReportScope = (field, value) => ({
  type: UPDATE_REPORT_SCOPE,
  field,
  value,
});
